import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { DataTable } from "./partial/DataTable"
import { columns } from "./partial/Columns"

const getListKelompokVerifikatorBerkasPasca = async (
  id_verberkas_pasca_rekap: string
) => {
  const response = await api.get(
    `/operator-pasca/verifikator-berkas/show-kelompok/${id_verberkas_pasca_rekap}`,
    {
      withCredentials: true,
    }
  )
  return response.data
}

export default function SettingVerifikatorPascaDetailPage() {
  const [searchParams] = useSearchParams()
  const idVerBerkasPasca = searchParams.get("id")

  const { data, isPending } = useQuery({
    queryKey: ["listKelompokVerifikatorBerkasPasca", idVerBerkasPasca],
    queryFn: () =>
      getListKelompokVerifikatorBerkasPasca(String(idVerBerkasPasca)),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  )
}
